import React, { Component } from "react";
import PropTypes from "prop-types";
import "bootstrap";
import { connect } from "react-redux";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import i18next from "i18next";
import confirm, { confirmComment } from "@mnjsplatform/components/lib/common/ConfirmFn";
import PopupWrapper from "@mnjsplatform/components/lib/common/PopupWrapper";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import downloadjs from "downloadjs";
import DropDownMenuComboLink from "@mnjsplatform/components/lib/common/DropdownMenu/DropDownMenuComboLink";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import { Link } from "react-router-dom";
import queryString from "query-string";
import { formObjectToRouteMap } from "../Navigation/Routes";
import {withRouter} from 'react-router';
import {buildReport} from "@mnjsplatform/data/lib/actions/reportActions";
import ReportBuildViewer from "@mnjsplatform/components/lib/common/Reports/ReportBuildViewer";
import TransportReqCard from "./TransportReqCard";
import TransportReqCardShowModeMenu from "./TransportReqCardShowModeMenu";
import toastr from 'toastr';
import RequisitesFindForm from "../SubComponents/RequisitesFindForm";
import {workplaceCountries} from "../../actions/AppActions";
import {isValidPhone} from "@mnjsplatform/components/lib/common/MnInlinePhoneEdit";

class TransportReqList extends Component {
  constructor(props, context) {
    super(props, context);


    this.state = {
      isLoading: true,
      updateGridFlag: null,
      isRequestEditorOpen: false,
      isCreateTLOpen: false,
      TLRow: null,
      newAuctionCount: 0,
      newTransportRequestCount: 0,
      cardShowMode: 1,
      requisitesFindVisible: false,
      trackingFormData: null
    };

    this.informerTimerId = null;
    this.dataForCopy = null;
    this.fieldsForSave = null;
  }

  componentDidMount() {
    this.setState({isLoading: true});

    this.refreshInformer();

    const execParams = this.getExecParamsFromQueryString(this.props.location);

    this.props.dispatch(this.props.transportReq.execute(execParams, {withParams: true, persistParamSet: false}))
      .finally(() => this.setState({isLoading: false}));
  }

  componentWillUpdate(nextProps, nextState, nextContext) {

    if(nextProps.location.search && this.props.location.search !== nextProps.location.search) {
      const params = queryString.parse(nextProps.location.search);

      if(params["ShowOnlyNew"] != null) {
        this.onRefreshFormClick(nextProps.location);
      }

    }
  }

  componentWillUnmount() {

    if(this.informerTimerId != null) {
      clearTimeout(this.informerTimerId);
      this.informerTimerId = null;
    }

    // Object.values(this.state.subGridKeys).forEach((value) => {
    //   this.props.dispatch(unmountSubgrid(this.props.transportReq, value));
    // });
  };

  refreshInformer = () => {
    this.informerTimerId = null;

    this.props.dispatch(this.props.transportInformerItem.execute())
      .then(data => {

        let auctionCount = 0;
        let transportReqCount = 0;

        if(this.props.transportInformerItem.rawData.DataTable) {
          this.props.transportInformerItem.rawData.DataTable.forEach((row, rowIndex) => {

            if (row.Document_Object === "TenderDocumentRels")
              auctionCount = row.CountNew == null ? 0 : row.CountNew;
            else if (row.Document_Object === "PickupList")
              transportReqCount = row.CountNew == null ? 0 : row.CountNew;
          });
        }

        //auctionCount = this.state.newAuctionCount + 1;
        //transportReqCount = this.state.newTransportRequestCount + 1;

        this.informerTimerId = setTimeout(this.refreshInformer, 5*60*1000);
        this.setState({newAuctionCount: auctionCount, newTransportRequestCount: transportReqCount});
      });
  };

  onRefreshFormClick = (location) => {

    this.setState({isLoading: true});

    //this.resetAllSubgrids();

    let execParams = {};

    if(location)
      execParams = this.getExecParamsFromQueryString(location);

    this.props.dispatch(this.props.transportReq.execute(execParams, {withParams: true, persistParamSet: false}))
      .finally(() => {

        if(this.informerTimerId != null) {
          clearTimeout(this.informerTimerId);
          this.informerTimerId = null;
        }

        this.refreshInformer();
        this.setState({isLoading: false})
      });
  };

  onExportToExcelButtonClick = (row, rowIndex) => {
    const reportId = "WEBListPL";

    this.props.dispatch(buildReport(reportId, this.props.transportReqParams.getRow(0)));
  };

  getExecParamsFromQueryString(location) {

    if(!location)
      return {};

    const queryParams = queryString.parse(location.search);
    let newQueryParams = {};
    const execParams = {};
    if(queryParams["ShowOnlyNew"] != null) {
      execParams["ShowOnlyNew"] = queryParams["ShowOnlyNew"];

      let hasParams = false;

      Object.keys(queryParams).forEach((key) => {
        if(key !== "ShowOnlyNew") {
          hasParams = true;
          newQueryParams[key] = queryParams[key];
        }
      });

      if(hasParams) {
        let path = location.pathname + '?' + queryString.stringify(newQueryParams);
        this.props.history.replace(path);
      }
      else
        this.props.history.replace(location.pathname);
    }

    return execParams;
  };

  onAcceptButtonClick = (row, rowIndex) => {

    confirm(i18next.t("AcceptRequirement"))
      .then(async() => {
        await this.props.dispatch(this.props.transportReq.setField(rowIndex, "IsAccept", 1));
        await this.props.dispatch(this.props.transportReq.save(rowIndex));
        await this.props.dispatch(this.props.transportReq.refresh());
        this.refreshInformer();
      });
  };

  onRefuseButtonClick = (row, rowIndex) => {
    confirmComment(i18next.t("RefuseRequirementAcceptance"),{commentRequired: false})
      .then(async(comment) => {
        await this.props.dispatch(this.props.transportReq.setFields(rowIndex, {RefuseAccept: 1, TransportCompanyComment: comment}));
        await this.props.dispatch(this.props.transportReq.save(rowIndex));
        await this.props.dispatch(this.props.transportReq.refresh());
        this.refreshInformer();
      });
  };

  onEditButtonClick = async (row, rowIndex) => {

    await this.props.dispatch(this.props.transportReqEdit.reset());
    await this.props.dispatch(this.props.transportReqEdit.initialize(row));
    this.setState({isRequestEditorOpen: true});
  };

  getFieldsForCopy = (row) => {
    if(!row.Fields2Copy)
      return null;

    return row.Fields2Copy.split(",");
  };

  onSaveDataForCopy = (row, rowIndex) => {

    let fieldList = this.getFieldsForCopy(row);

    if(fieldList === null)
      return;

    this.saveDataForCopy(row, fieldList);
  };

  saveDataForCopy = (row, fieldList) => {

    let dataForCopy = {};
    fieldList.forEach((node) => {
      dataForCopy[node] = row[node];
    });

    this.dataForCopy = dataForCopy;

    toastr.options = {
      "closeButton": false,
      "debug": false,
      "newestOnTop": false,
      "progressBar": false,
      "positionClass": "toast-top-center",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "4000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    };

    toastr.success(i18next.t("TransportReqList_DataCopied"));
  };

  applyCopiedData = (dataItem, rowIndex) => {
    if(this.dataForCopy == null)
      return;

    this.props.dispatch(dataItem.setFields(rowIndex, this.dataForCopy));
  };

  getBufferData = () => {
    return this.dataForCopy;
  };

  onCreateTLButtonClick = (row, rowIndex) => {
    this.props.dispatch(this.props.transportReqTLCreate.reset())
      .then(() => {this.props.dispatch(this.props.transportReqTLCreate.initialize(row))})
      .then(() => {this.setState({isCreateTLOpen: true, TLRow: row});})
  };

  onConfirmCreateTL = () => {
    this.props.dispatch(this.props.transportReqTLCreate.save())
      .then(() => {


        if(this.props.transportReqTLCreate.isError)
          return;

        this.setState({isCreateTLOpen: false, TLRow: null});

        let xml = this.props.transportReqTLCreate.getField(0, "XML");

        downloadjs(xml, "TL.xml", "application/xml");
      })
  };

  onCancelCreateTL = () => {
    this.setState({isCreateTLOpen: false, TLRow: null});
  };

  renderCreateTLEditor = () => {
    if(!this.state.isCreateTLOpen)
      return null;

    const title = i18next.t('TransportRequestsCreateTLTitle');
    const applyButtonText = i18next.t('TransportRequestsCreateTLSaveButton');
    const item = this.props.transportReqTLCreate;
    const saveFunc = this.onConfirmCreateTL;

    const renderButtons = () => {
      return (<div className="modal-footer text-right">
        <div className="text-right">
          <button className="btn btn-regular float-left"
                  onClick={this.showRequisitesFindForm}
          >
            {i18next.t("CopyRequisites")}
          </button>
          <button className="btn btn-regular mr-2" onClick={saveFunc}>{applyButtonText}</button>
          <button className="btn btn-regular" onClick={this.onCancelCreateTL}>{i18next.t('Cancel')}</button>
        </div>
      </div>);
    };

    return (
      <PopupWrapper popupVisible title={title}
                    onClose={this.onCancelCreateTL}
                    renderButtons={renderButtons}>
        <ComplexParam dataItem={item}
                      rootPath="/"
                      renderParams={paramRender}
                      rowIndex={0} />
      </PopupWrapper>);
  };
  
  showRequisitesFindForm = (e) => {
    e.preventDefault();
    this.setState({requisitesFindVisible: true});
  };

  hideRequisitesFindForm = () => {
    this.setState({requisitesFindVisible: false});
  };

  onSelectRequisites = async(fields) => {
    await this.props.dispatch(this.props.transportReqTLCreate.setFields(0, fields));
    this.hideRequisitesFindForm();
  };

  renderRequisitesFind = () => {
    if (!this.state.requisitesFindVisible) {
      return null;
    }

    if (!this.props.transportReqParams.isInitialized) {
      return null;
    }

    return (
      <RequisitesFindForm TLRow={this.state.TLRow}
                          onSelectRequisites={this.onSelectRequisites}
                          onClose={this.hideRequisitesFindForm}
      />
    );
  };

  onCancelRequestEdit = () => {
    this.setState({isRequestEditorOpen: false});
  };

  onConfirmRequestEdit = () => {
    this.props.dispatch(this.props.transportReqEdit.save())
      .then(() => this.setState({isRequestEditorOpen: false}))
      .then(() => this.props.dispatch(this.props.transportReq.refresh()))
  };

  sortSelected = (menuItem) => {
    this.props.dispatch(this.props.transportReq.sortRows(menuItem.MenuItemId, menuItem.SortIsAsc))
  };

  sortClear = () => {
    this.props.dispatch(this.props.transportReq.clearSort())
  };

  renderRequestEditor = () => {
    if(!this.state.isRequestEditorOpen)
      return null;

    const title = i18next.t('TransportRequestsEditTitle');
    const applyButtonText = i18next.t('Save');
    const item = this.props.transportReqEdit;
    const saveFunc = this.onConfirmRequestEdit;

    const renderButtons = () => {
      return (<div className="modal-footer text-right">
        <div className="text-right">
          {this.dataForCopy != null &&
              <button className="btn btn-regular" style={{marginRight: "15px"}} onClick={() => this.applyCopiedData(item, 0)}>{i18next.t("PasteRequisites")}</button>
          }
          <button className="btn btn-regular" onClick={saveFunc}>{applyButtonText}</button>
          <button className="btn btn-regular" onClick={this.onCancelRequestEdit}>{i18next.t('Cancel')}</button>
        </div>
      </div>);
    };

    return (
      <PopupWrapper popupVisible title={title}
                    onClose={this.onCancelRequestEdit}
                    renderButtons={renderButtons}
                    minHeightBody={'200px'}>
        <ComplexParam dataItem={item}
                      rootPath="/"
                      renderParams={paramRender}
                      rowIndex={0} />
      </PopupWrapper>);
  };

  onGPSEditButtonClick = async(row, rowIndex) => {
    await this.props.dispatch(this.props.transportReqSetGPS.reset());
    const params = {
      GPSId: row["GPSId"],
      GPSName: row["GPSName"],
      GPSPhoneId: row["GPSPhoneId"],
      PickupList_Object: row["PickupList_Object"],
      PickupListDate: row["PickupListDate"],
      PickupListNumber: row["PickupListNumber"],
      TransportCompanyId: row["TransportCompanyId"]
    };
    await this.props.dispatch(this.props.transportReqSetGPS.initialize(params, {withParams: true, refresh: false}));
    this.setState({trackingFormData: {row, rowIndex}});
  };

  onGPSEditFormClose = () => {
    this.setState({trackingFormData: null});
  };

  onGPSEditFormSave = async() => {
    await this.props.dispatch(this.props.transportReqSetGPS.applyParams(this.props.transportReqSetGPSParams));
    this.setState({trackingFormData: null}, async() => {
      await this.props.dispatch(this.props.transportReq.refresh());
    });
  };

  onGPSEditFormEndEditField = async(rowIndex, fieldDescriptor, forceApplyParams) => {
    if (fieldDescriptor.Value) {
      if (fieldDescriptor.Name === "GPSPhoneId" && this.props.transportReqSetGPSParams.getField(0, "GPSId")) {
        await this.props.dispatch(this.props.transportReqSetGPSParams.setFields(rowIndex, {
          GPSId: null,
          GPSName: null
        }));
        await this.props.dispatch(this.props.transportReqSetGPSParams.save());
      }
      else if (fieldDescriptor.Name === "GPSName" && this.props.transportReqSetGPSParams.getField(0, "GPSPhoneId")) {
        await this.props.dispatch(this.props.transportReqSetGPSParams.setField(rowIndex, "GPSPhoneId", null));
      }
    }
  };

  renderGPSEditFormParams = (h) => {
    return (
      <>
        <div className="row mb-2">
          <div className="col-12">
            <span style={{whiteSpace: "pre-line"}}>{i18next.t("GPSEditInstruction")}</span>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-md-3 field-title">
            {h.lbl("GPSName")}
          </div>
          <div className="col-md-9">
            {h.ed("GPSName")}
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 field-title">
            {h.lbl("GPSPhoneId")}
          </div>
          <div className="col-md-9">
            {h.ed("GPSPhoneId")}
          </div>
        </div>
      </>
    );
  };

  renderGPSEditFormButtons = () => {
    const gpsId = this.props.transportReqSetGPSParams.getField(0, "GPSId");
    let gpsPhoneId = this.props.transportReqSetGPSParams.getField(0, "GPSPhoneId");
    if (gpsPhoneId) {
      let rfi = this.props.transportReqSetGPSParams.rawData.ResultFieldInfo.filter(r => r.Name === "GPSPhoneId");
      if (rfi.length) {
        rfi = rfi[0];
        if (!isValidPhone(gpsPhoneId, rfi.EditorForm.FormOptions.BoilerPicture)) {
          gpsPhoneId = "";
        }
      }
    }
    const showApplyButton = (
      (gpsId || gpsPhoneId)
      && (
        this.state.trackingFormData.row["GPSId"] !== gpsId
        || this.state.trackingFormData.row["GPSPhoneId"] !== gpsPhoneId
      )
    );

    return (
      <div className="modal-footer text-right">
        {showApplyButton &&
        <button type="button" className="btn btn-regular -goahead" data-dismiss="modal"
                onClick={this.onGPSEditFormSave}>{i18next.t("SendForTracking")}</button>
        }
        <button type="button" className="btn btn-regular -default mr-0" data-dismiss="modal"
                onClick={this.onGPSEditFormClose}>{i18next.t('Close')}</button>
      </div>
    );
  };

  renderGPSEditForm = () => {
    if (!this.state.trackingFormData) {
      return null;
    }

    return (
      <PopupWrapper popupVisible
                    onClose={this.onGPSEditFormClose}
                    title={i18next.t("Tracking")}
                    renderButtons={this.renderGPSEditFormButtons}
      >
        <ComplexParam dataItem={this.props.transportReqSetGPSParams}
                      showSearchBar={false}
                      autoApplyParams={false}
                      showApplyButton={false}
                      renderParams={this.renderGPSEditFormParams}
                      onEndEditField={this.onGPSEditFormEndEditField}
        />
      </PopupWrapper>
    );
  };

  renderParams = (h) => {

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-3">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("InterCompanyName")}
            </div>
            <div>
              {h.ed("InterCompanyName")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("PlanDate")}
            </div>
            <div>
              {h.ed("PlanDate")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("EndDate")}
            </div>
            <div>
              {h.ed("EndDate")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("DateType")}
            </div>
            <div>
              {h.ed("DateType")}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("SrcCityName")}
            </div>
            <div>
              {h.ed("SrcCityName")}
            </div>
          </div>
          <div className="col-md-3">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("DstCityName")}
            </div>
            <div>
              {h.ed("DstCityName")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("StatusList")}
            </div>
            <div>
              {h.ed("StatusList")}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-7">
            <div className="field-title" style={{textAlign: "left"}}>
              {i18next.t("SearchLabel")}
            </div>
            <SearchBar dataItem={this.props.transportReq}/>
          </div>
          <div className="col-md-5">
            <div className="field-title" style={{textAlign: "left"}}>
              &nbsp;
            </div>
            <div className="row">
            {this.renderSortMenu()}
            <TransportReqCardShowModeMenu currentShowMode={this.state.cardShowMode} onModeSelect={this.onCardShowModeChanged}/>
            </div>
          </div>
        </div>
      </React.Fragment>)
  };

  onCardShowModeChanged = (modeId) => {
    this.setState({cardShowMode: modeId, updateGridFlag: Date.now()});
  };

  renderRow = (row, rowIndex, renderRowDefault, dataItem) => {

    return (
      <TransportReqCard dataItem={dataItem}
                        row={row}
                        rowIndex={rowIndex}
                        routeSubGridColumnName={"ComplexRouteGrid"}
                        showMode={this.state.cardShowMode}
                        onAcceptTransportReq={this.onAcceptButtonClick}
                        onRefuseTransportReq={this.onRefuseButtonClick}
                        onEditTransportReq={this.onEditButtonClick}
                        onSaveDataForCopy={this.onSaveDataForCopy}
                        onCreateTL={this.onCreateTLButtonClick}
                        onGPSEdit={this.onGPSEditButtonClick}
                        onCardDataChanged={this.onRefreshFormClick}
                        getBufferData={this.getBufferData}
      />
    );
  };

  renderSortMenu = () => {

    if(!this.props.transportReq.isInitialized)
      return null;

    const sortMenuProvider = new SortMenuProvider(this.props.transportReq);
    let currentSort = this.props.transportReq.getSort();

    return (
      <React.Fragment>
        <div className="field-title fs16" style={{display: "flex", alignItems: "center", marginLeft: "15px", marginRight: "10px"}}>
          <span style={{display: "flex"}}>{i18next.t('SortbyLabel')}</span>
        </div>
        <div>
          <DropDownMenuComboLink menuAdapter={sortMenuProvider} onSelected={this.sortSelected}/>
        </div>
        {currentSort && currentSort.SortColumn &&
        <div>
          <button className="btn btn-input -link" style={{ marginLeft: "15px" }} onClick={(e) => { e.preventDefault(); this.sortClear(); }}>{i18next.t("ResetSorting")}</button>
        </div>
        }
      </React.Fragment>
      );
  };

  render() {

    if(this.state.isLoading)
      return (<div>{i18next.t("LoadingLabel")}</div>);

    const qs = queryString.stringify({"ShowOnlyNew": 1});
    let trasportInformerLink =  "/" + formObjectToRouteMap["TransportReqList"].link + "?" + qs;
    let auctionInformerLink =  "/" + formObjectToRouteMap["AuctionList"].link + "?" + qs;

    return (
      <React.Fragment>
        <ReportBuildViewer/>
        <div className="row" style={{marginTop: "10px", marginBottom: "10px"}}>
          <div className="col-md-8">
            <h1 className="page-title" style={{display: 'inline-block', marginRight: '25px'}}>
              {i18next.t("TransportRequestsTitle")}
            </h1>
            <button className="btn btn-regular btn-carrier-action -goahead" onClick={this.onRefreshFormClick}>{i18next.t("RefreshData")}</button>
            {this.props.workplaceCountry === workplaceCountries.RUS && this.props.transportReqParams.isInitialized &&
            <button className="btn btn-regular btn-carrier-action -goahead" onClick={this.onExportToExcelButtonClick}>{i18next.t("ExportToExcel")}</button>
            }
          </div>
          <div className="col-md-4" style={{textAlign: "right", paddingRight: "45px"}}>
            {this.state.newTransportRequestCount > 0
            && (trasportInformerLink ?
              <Link style={{color: "green", fontWeight: 'bold'}}
                    to={trasportInformerLink}>
                {i18next.t("NewRequirementsCount")}:&nbsp;{this.state.newTransportRequestCount}
              </Link>
              : <span style={{color: "green", fontWeight: 'bold'}}>{i18next.t("NewRequirementsCount")}:&nbsp;{this.state.newTransportRequestCount}</span>)
            }
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {this.state.newAuctionCount > 0
            && (auctionInformerLink ?
              <Link style={{color: "green", fontWeight: 'bold'}}
                    to={auctionInformerLink}>
                {i18next.t("NewAuctionsCount")}:&nbsp;{this.state.newAuctionCount}
              </Link>
              : <span style={{color: "green", fontWeight: 'bold'}}>{i18next.t("NewAuctionsCount")}:&nbsp;{this.state.newAuctionCount}</span>)
            }
          </div>
        </div>

        <ComplexParam dataItem={this.props.transportReqParams}
                      readOnly={false}
                      showSearchBar={false}
                      showApplyButton={false}
                      autoApplyParams
                      rootPath="/"
                      parentDataItem={this.props.transportReq}
                      cardShowMode = {this.state.cardShowMode}
                      renderParams={this.renderParams} />

        <div className="row">{this.props.transportReq
                              && this.props.transportReq.rowsCount() > 0
                              ? <span className={"col-md-12"} style={{fontWeight: 'bold'}}>{i18next.t("AllRequirementsCount")}:&nbsp;{this.props.transportReq.rowsCount()}</span>
                              : <span>&nbsp;</span>}
        </div>

        <div style={{marginLeft: "-15px", marginRight: "-15px"}}>
          <GridView dataItem={this.props.transportReq}
                    allowPagination
                    activePageSize={12}
                    pageSize={12}
                    renderRow={this.renderRow}
                    showHeader={false}
                    flexBox
                    flexBoxWidthPercent={100}
                    updateStateFlag={this.state.updateGridFlag}/>
        </div>

        {this.renderCreateTLEditor()}
        {this.renderRequisitesFind()}
        {this.renderRequestEditor()}
        {this.renderGPSEditForm()}
      </React.Fragment>
    );
  }
}

class SortMenuProvider {

  constructor(dataItem) {
    this.currentSort = dataItem.getSort();
    this.items = dataItem.getSortableFields().slice()
      .sort((a, b) => (a.Header > b.Header) ? 1 : ((b.Header > a.Header) ? -1 : 0))
      .map(sf => {

        const isActiveColumn = sf.Name === this.currentSort.SortColumn;

        return {
          MenuItemId: sf.Name,
          MenuText: isActiveColumn ? this.getDirSign() + " " + sf.Header : sf.Header,
          IsActive: isActiveColumn,
          SortIsAsc: isActiveColumn ? !this.currentSort.SortIsAsc : true
        }
      });
  }

  getMenuItems() {
    return this.items;
  }

  getVisibleItemsCount() {
    return 1;
  }

  getDropDownText() {
    const i = this.items.find(i => i.MenuItemId === this.currentSort.SortColumn);
    if (i) {
      return i.MenuText + "";
    }

    return "";
  }

  getDirSign() {
    return (!this.currentSort.SortIsAsc ? "↑" : "↓")
  }
}

TransportReqList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  transportReqSetGPS: PropTypes.object,
  transportReqSetGPSParams: PropTypes.object
};


TransportReqList.defaultProps = {
  //myProp: <defaultValue>
};

function mapStateToProps(state, ownProps) {
  const workplaceCountry = state.appState.appParams.workplaceCountry;

  return {
    transportReq: workplaceCountry === workplaceCountries.UKR
      ? state.transportState.transportReqUA
      : state.transportState.transportReq,
    transportReqParams: workplaceCountry === workplaceCountries.UKR
      ? state.transportState.transportReqUAParams
      : state.transportState.transportReqParams,
    transportReqTLCreate: state.transportState.transportReqTLCreate,
    transportReqEdit: workplaceCountry === workplaceCountries.UKR
      ? state.transportState.transportReqEditUA
      : state.transportState.transportReqEdit,
    transportInformerItem: state.transportState.transportInformerItem,
    transportReqSetGPS: state.transportState.transportReqSetGPS,
    transportReqSetGPSParams: state.transportState.transportReqSetGPSParams,
    workplaceCountry: workplaceCountry
  };
}

export default withRouter(connect(mapStateToProps)(TransportReqList));